<template>
  <div class="wrapper">
    <!-- div @click="method1" class="ddd">НАЖМИ</div -->
    <!-- Install button (PWA) -->
    <div v-if="0" style="position: fixed; top: 12px; right: 12px; z-index: 9999">
      <button v-if="showInstallBtn" class="btn-install" @click="onInstallClick">Установить приложение</button>
    </div>
    <!-- start services -->
    <section id="services" class="services section">
      <div class="container-fluid">
        <div class="section-header">
          <div class="line"></div>
          <h2>Stack.</h2>
          <h4>Навыки и умения</h4>
        </div>
        <div class="services-list">
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-strategy"></i>
              </div>
              <div class="title-item">
                <h5>Языки программирования</h5>
                JavaScript, TypeScript, Jquery
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-browser"></i>
              </div>
              <div class="title-item">
                <h5>Фреймворки и платформы</h5>
                Vue.js, Nuxt.js, Bitrix, Laravel, PWA
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-presentation"></i>
              </div>
              <div class="title-item">
                <h5>Стилизация и препроцессоры</h5>
                LESS, SASS, SCSS, Stylus
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-clipboard2"></i>
              </div>

              <div class="title-item">
                <h5>Инструменты и сборщики</h5>
                Vite,Webpack, Gulp, Docker
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-tools"></i>
              </div>

              <div class="title-item">
                <h5>Работа с дизайном</h5>
                Photoshop, Figma, Avocode, Zeplin
              </div>
            </div>
          </div>

          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-graduation-hat"></i>
              </div>

              <div class="title-item">
                <h5>Методологии и подходы</h5>
                BEM, PUG, Responsive и Adaptive
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-target"></i>
              </div>

              <div class="title-item">
                <h5>Знаю разницу между responsive(RWD) и adaptive(ADW) версткой</h5>
              </div>
            </div>
          </div>

          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-lightbulb"></i>
              </div>
              <div class="title-item">
                <h5>Качество кода</h5>
                ESLint, Prettier
              </div>
            </div>
          </div>
          <div class="services__item-wrapper">
            <div class="services__item">
              <div class="pr-service-box-icon-wrap">
                <i class="icon icon-basket"></i>
              </div>
              <div class="title-item">
                <h5>Оптимизация</h5>
                Улучшение производительности и скорости
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!-- end services -->
    <!-- start portfolio -->
    <ListProjects />
    <!-- end portfolio -->
    <section id="about" class="impact section">
      <div class="container-fluid">
        <div class="section-header">
          <div class="line"></div>
          <h2>Обо мне.</h2>
        </div>
      </div>
      <div class="container-fluid">
        <div class="impact__items">
          <div class="col-about">
            <p>
              Я front-end веб-разработчик с более чем 14-летним опытом в создании высокопроизводительных и
              многофункциональных интерактивных веб-сайтов. Моя работа охватывает широкий спектр проектов, и я активно
              сотрудничаю с агентствами по всему миру, чтобы предоставлять качественные решения, которые работают на
              всех устройствах и платформах.
            </p>

            <p>
              Мой путь в веб-разработке начался с HTML и CSS, и я помню, как искал хаки для IE6. С тех пор я значительно
              расширил свои навыки и сейчас активно использую современные технологии.
            </p>

            <h3>Профессиональные навыки</h3>
            <p>
              <strong>Frontend-разработка:</strong> Глубокое знание Vue.js (5,5 года) и Nuxt.js (4,5 года), включая
              оптимизацию производительности и миграцию проектов с Vue 2 на Vue 3. Умею применять Bootstrap и другие
              фреймворки, когда это действительно необходимо.
            </p>

            <p>
              <strong>Оптимизация производительности:</strong> Опыт в оптимизации сайтов для достижения высоких
              показателей в Google Page Speed, включая настройку .htaccess и создание Турбо-страниц для Яндекса. Знаю,
              как улучшить сборки Webpack и Vite для повышения скорости загрузки.
            </p>

            <p>
              <strong>Разработка компонентов:</strong> Создаю сложные компоненты, такие как интерактивные карты, системы
              авторизации и регистрации пользователей, а также универсальные модальные окна.
            </p>

            <p>
              <strong>Микросервисы:</strong> Опыт разработки микросервисов, включая Telegram-ботов и другие сложные
              проекты.
            </p>

            <p>
              <strong>Инструменты сборки:</strong> Уверенное владение Webpack, Vite и Gulp, а также управление версиями
              с помощью Git и Docker.
            </p>

            <p>
              <strong>Типизация:</strong> Хорошее знание TypeScript и его применение в разработке Vue-приложений,
              включая работу с Composition API и Pinia для управления состоянием.
            </p>

            <p>
              <strong>UI и верстка:</strong> Профессиональная вёрстка HTML5/CSS3 с использованием БЭМ, адаптивная
              верстка и создание кастомных тем для приложений, таких как Wiki.js. Опыт работы с графическими редакторами
              Figma, Sketch, Photoshop и Adobe XD для интеграции дизайна.
            </p>

            <h3>Технологический стек</h3>
            <p>
              <strong>Frontend:</strong> Vue.js (2 и 3), Nuxt (2 и 3), Vuex, Pinia, Axios, Websocket.io, PrimeVue,
              chart.js
            </p>
            <p><strong>CSS-препроцессоры:</strong> LESS, SASS, SCSS, Stylus</p>
            <p><strong>HTML-препроцессоры:</strong> Pug</p>
            <p><strong>Backend:</strong> Laravel, Bitrix</p>

            <h3>Мой подход</h3>
            <p>
              Я придерживаюсь принципа «прогрессивного улучшения», находя творческие решения для расширения возможностей
              веб-сайтов без ущерба для производительности и поддержки браузеров. Открыт к сложным и интересным
              проектам, которые требуют глубокого анализа и нестандартных решений.
            </p>

            <h3>Личные интересы</h3>
            <p>В свободное время увлекаюсь автоспортом, люблю бег и занимаюсь плаванием.</p>
          </div>
          <div class="col-infograf">
            <div class="impact__item impact__item--second">
              <h3>Общение</h3>
              <p>Дружелюбно работаю в коллективе</p>
            </div>

            <div class="impact__item impact__item--third">
              <h3>Опыт</h3>
              <p>Активно проявляю инициативу</p>
            </div>
            <div class="impact__item impact__item--four">
              <h3>Креативность</h3>
              <p>Предлагаю и внедряю идеи, чтобы выделить продукт среди конкурентов.</p>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section reviews">
      <div class="b-reviews">
        <div class="col-img">
          <div class="rewievs-img">
            <img src="/img/img10.webp" alt="" loading="lazy" decoding="async" width="786" height="1000" />
          </div>
        </div>

        <div class="col-text">
          <div id="review" class="section-header">
            <div class="line"></div>
            <h2>Отзывы клиентов.</h2>
          </div>
          <p>
            "Роман на данный момент, наверное лучший front-end developer из всех, с которыми я имел опыт сотрудничать.
            Он постоянно находится в процессе совершенствования своих профессиональных навыков, умеет работать быстро и
            качественно, не боится нестандартных задач." -
            <strong>Michael Ivanov-Shuvalov</strong>, Head of project department
          </p>
          <div class="line-grey"></div>
        </div>
      </div>
    </section>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted, onBeforeUnmount } from 'vue';
import { useRuntimeConfig } from '#app';

/* Тип для beforeinstallprompt (ts) */
interface BeforeInstallPromptEvent extends Event {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform?: string }>;
}

/* util */
function urlBase64ToUint8Array(base64String: string) {
  const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);
  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}

const config = useRuntimeConfig();
const runtimeApiBase = typeof config.public?.apiBase === 'string' ? config.public.apiBase : '';
const apiBase = runtimeApiBase.replace(/\/$/, '');
const subscriptionEndpoint = apiBase ? `${apiBase}/api/subscription` : '/api/subscription';

/* Публичный VAPID ключ (должен совпадать с серверным) */
const vapidPublicKey = 'BP8wL9ir6-ChHqz619mhPdOoFthitxIotXySszuefTvrnMFPo0IyRpiTBQYuDfLQnYO2y1ZR_69-sLBavIC3O-0';

/* state */
const showInstallBtn = ref(false);
const deferredPrompt = ref<BeforeInstallPromptEvent | null>(null);

/* логирование (опционально) */
function log(...args: any[]) {
  console.log('[mainPage]', ...args);
}

/* helpers to expose for console/debug */
function exposeInstallHelpers() {
  // сохранение и helper доступны в window для удобства отладки
  (window as any)._getDeferredPrompt = () => deferredPrompt.value;
  (window as any).showPwaInstall = async () => {
    const dp = (window as any)._deferredPrompt || deferredPrompt.value;
    if (!dp) {
      console.warn('No deferredPrompt available');
      return null;
    }
    try {
      await dp.prompt();
      const choice = await dp.userChoice;
      // clear after prompt
      deferredPrompt.value = null(window as any)._deferredPrompt = null;
      showInstallBtn.value = false;
      return choice;
    } catch (err) {
      console.error('showPwaInstall error', err);
      deferredPrompt.value = null(window as any)._deferredPrompt = null;
      showInstallBtn.value = false;
      return null;
    }
  };
}

/* beforeinstallprompt handling */
function handleBeforeInstallPrompt(e: Event) {
  const ev = e as BeforeInstallPromptEvent;
  try {
    ev.preventDefault(); // контролируем показ сами
  } catch (err) {
    // ignore if browser doesn't allow
    log('preventDefault failed', err);
  }
  deferredPrompt.value = ev;
  // сохраняем глобально для отладки / консоли (удобно)
  (window as any)._deferredPrompt = ev;
  showInstallBtn.value = true;
  log('Captured beforeinstallprompt; showInstallBtn set');
  // оповестим приложение (если есть слушатели)
  window.dispatchEvent(new CustomEvent('pwa-beforeinstallprompt'));
}

/* install button click */
async function onInstallClick() {
  if (!deferredPrompt.value && !(window as any)._deferredPrompt) {
    log('Install prompt not available');
    return;
  }
  const dp = deferredPrompt.value || (window as any)._deferredPrompt;
  try {
    await dp.prompt();
    const choice = await dp.userChoice;
    log('User choice', choice);
  } catch (err) {
    log('prompt() error', err);
  } finally {
    deferredPrompt.value = null;
    (window as any)._deferredPrompt = null;
    showInstallBtn.value = false;
  }
}

/* отправка подписки на сервер */
async function sendSubscriptionToServer(subscriptionJson: any) {
  log('sendSubscriptionToServer', subscriptionJson);
  if (!subscriptionJson || !subscriptionJson.endpoint) {
    throw new Error('Invalid subscription object (missing endpoint)');
  }
  const res = await fetch(subscriptionEndpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(subscriptionJson),
  });
  if (!res.ok) {
    const text = await res.text();
    throw new Error(`Server responded ${res.status}: ${text}`);
  }
  try {
    return await res.json();
  } catch {
    return {};
  }
}

/* onMounted: beforeinstallprompt + push subscribe flow */
const beforeInstallHandler = handleBeforeInstallPrompt as EventListener;
let pwaBeforeInstallListener = () => {
  /* noop placeholder for cleanup */
};

onMounted(async () => {
  // expose helpers for console
  exposeInstallHelpers();

  // Если плагин/другой код может перехватить раньше, слушаем событие глобально.
  window.addEventListener('beforeinstallprompt', beforeInstallHandler);

  // Если кто-то (плагин) диспатчит 'pwa-beforeinstallprompt', показываем кнопку
  pwaBeforeInstallListener = () => {
    showInstallBtn.value = true;
  };
  window.addEventListener('pwa-beforeinstallprompt', pwaBeforeInstallListener);

  // Если уже где-то положили событие в window (например плагин), учитываем это
  if ((window as any)._deferredPrompt) {
    deferredPrompt.value = (window as any)._deferredPrompt;
    showInstallBtn.value = true;
    log('Found existing window._deferredPrompt on mount');
  }

  try {
    if (!('serviceWorker' in navigator) || !('PushManager' in window)) {
      log('Push/ServiceWorker not supported');
      return;
    }

    log('Waiting for navigator.serviceWorker.ready...');
    const swReg = await navigator.serviceWorker.ready;
    log('SW ready, scope =', swReg.scope);

    // permission
    if (Notification.permission === 'default') {
      const perm = await Notification.requestPermission();
      log('Notification permission:', perm);
      if (perm !== 'granted') {
        log('User denied notifications');
        // не выходим — можно показывать install prompt
        // but if you want to exit early, uncomment next line:
        // return
      }
    } else if (Notification.permission === 'denied') {
      log('Notifications denied by browser settings');
      // you may decide to return here
    }

    // check existing subscription
    const existing = await swReg.pushManager.getSubscription();
    if (existing) {
      log('Existing subscription found — sending to server (update)');
      try {
        await sendSubscriptionToServer(existing.toJSON());
        log('Existing subscription sent');
      } catch (err) {
        log('Error sending existing subscription:', err);
      }
    } else {
      // create new subscription
      const applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
      const subscription = await swReg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey,
      });
      log('New subscription:', subscription);
      try {
        await sendSubscriptionToServer(subscription.toJSON());
        log('Subscription sent to server (new)');
      } catch (err) {
        log('Error sending new subscription:', err);
      }
    }
  } catch (err) {
    log('Push subscription flow error:', err);
  }
});

onBeforeUnmount(() => {
  window.removeEventListener('beforeinstallprompt', beforeInstallHandler);
  window.removeEventListener('pwa-beforeinstallprompt', pwaBeforeInstallListener);
  // cleanup exposed globals (optional)
  try {
    delete (window as any)._getDeferredPrompt;
    delete (window as any).showPwaInstall;
    delete (window as any)._deferredPrompt;
  } catch (e) {
    /* ignore */
  }
});
</script>
